import React from 'react';
import * as translator from '../../../utils/translator';
import invalidIllustration from '../../../images/repay/link-invalid-illustration.png';
import RepayButton from './RepayButton';

interface RepayInvalidLinkStateProps {
  language: string;
  onMyOrders: () => void;
  onContactUs: () => void;
}

const RepayInvalidLinkState: React.FC<RepayInvalidLinkStateProps> = ({ language, onMyOrders, onContactUs }) => {
  return (
    <div data-testid="repay-invalid-state" className="flex flex-col items-center py-[60px] px-[16px] text-center">
      <img src={invalidIllustration} alt="" className="w-[120px] h-auto mb-[16px]" />
      <h1 className="font-poppins font-bold text-[#0d2c54] text-[24px] md:text-[32px] mb-[8px] max-w-[600px]">
        {translator.translate(language, 'repay', 'invalid/title')}
      </h1>
      <p className="font-poppins text-[#656d79] text-[14px] mb-[24px] max-w-[347px]">
        {translator.translate(language, 'repay', 'invalid/subtitle')}
      </p>
      <div className="flex flex-col sm:flex-row gap-[12px] w-full max-w-[400px]">
        <RepayButton variant="solid" onClick={onMyOrders}>
          {translator.translate(language, 'repay', 'invalid/my_orders')}
        </RepayButton>
        <RepayButton variant="outline" onClick={onContactUs}>
          {translator.translate(language, 'repay', 'invalid/contact_us')}
        </RepayButton>
      </div>
    </div>
  );
};

export default RepayInvalidLinkState;
